import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import { Row, Col } from 'react-bootstrap';
import SelectField from '../../passengerInfo/selectField/SelectField';
import SelectBox from '../../common/selectBox/SelectBox';
import I18n from 'i18n-react';
import './CardValidDate.css';
import EyeEncode from '../eyeEncode/EyeEncode';

const propTypes = {
  id: PropTypes.string.isRequired,
  changeValue: PropTypes.func.isRequired,
  cardMonthYearSelectFieldToggle: PropTypes.bool
};

class CardValidDate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isDateValid: true,
      cardMonthYearSelectFieldToggle: false
    };
  }

  componentWillMount() {
    this.setState({
      cardMonthYearSelectFieldToggle: this.props.cardMonthYearSelectFieldToggle
    });
  }

  componentWillReceiveProps(nextProps) {
    let cardMonthYearSelectFieldToggle = nextProps.cardMonthYearSelectFieldToggle;
    if (cardMonthYearSelectFieldToggle !== this.props.cardMonthYearSelectFieldToggle) {
      this.setState({
        cardMonthYearSelectFieldToggle: cardMonthYearSelectFieldToggle
      });
    }
  }

  validate = () => {
    let isDateValid = this.validateDate();
    let monthValid = this.monthField.validate();
    let yearValid = this.yearField.validate();

    return monthValid && yearValid && isDateValid;
  };

  renderMessageDateInvalid() {
    if (!this.state.isDateValid) {
      return (
        <Row>
          <Col xs={12} className="Field__message CardValidDate__error">
            <span className="CardValidDate__invalidField">
              {I18n.translate('components.checkoutInfo.cardValidDate.invalidDateErrorMessage')}
            </span>
          </Col>
        </Row>
      );
    }
  }

  validateDate() {
    let isDateValid = !(
      this.state.year &&
      this.state.month &&
      this.state.year === Moment().format('YYYY') &&
      parseInt(this.state.month, 10) < parseInt(Moment().format('M'), 10)
    );
    this.setState({
      isDateValid: isDateValid
    });
    return isDateValid;
  }

  changeYear = value => {
    this.setState({ year: value });
    if (this.state.month) {
      this.validateDate();
    }
    this.props.changeValue(this.state.month, value);
  };

  changeMonth = value => {
    this.setState({ month: value });
    if (this.state.year) {
      this.validateDate();
    }
    this.props.changeValue(value, this.state.year);
  };

  getYears() {
    let years = [];
    for (let i = 0; i <= 20; i++) {
      years.push(Number(Moment().format('YYYY')) + i);
    }

    return years.map(String);
  }

  getMonths() {
    let months = [];
    for (let i = 1; i <= 12; i++) {
      months.push(i);
    }

    return months.map(String);
  }  

  renderCombo() {
    if (this.state.cardMonthYearSelectFieldToggle) {
      return (
        <div>
          <Row id={`cardValidDate-${this.props.id}`}>          
            <Col xs={5}>            
             <SelectBox
                id={`cardValidDate-month`}
                label="components.checkoutInfo.cardValidDate.label"
                required={true}
                errorMessage="components.checkoutInfo.cardValidDate.monthRequired"
                placeholder="components.checkoutInfo.cardValidDate.month"
                values={this.getMonths()}
                ref={c => {
                  this.monthField = c;
                }}
                changeValue={this.changeMonth}
                style={this.props.styleEncodeMonth}
                onBlurFieldToIco={this.props.onBlurFieldToIco}                
                styleFieldIdentifier = {'styleFieldMonth'}
                iconIdentifier = {'iconMonth'} 
                callCenterMode={this.props.callCenterMode} 
              />
            </Col>
            <Col xs={1}> 
             {this.renderEyeEncode(this.props.iconEyeMonth,this.props.iconIdentifierMonth,this.props.styleFieldIdentifierMonth)}
            </Col>
            <Col xs={5}>              
              <SelectBox
                id={`cardValidDate-year`}
                required={true}
                errorMessage="components.checkoutInfo.cardValidDate.yearRequired"
                placeholder="components.checkoutInfo.cardValidDate.year"
                values={this.getYears()}
                ref={c => {
                  this.yearField = c;
                }}
                changeValue={this.changeYear}
                style={this.props.styleEncodeYear}
                onBlurFieldToIco={this.props.onBlurFieldToIco}                
                styleFieldIdentifier = {'styleFieldYear'}
                iconIdentifier = {'iconYear'} 
                callCenterMode={this.props.callCenterMode} 
              />
            </Col>
            <Col xs={1}>
             {this.renderEyeEncode(this.props.iconEyeYear,this.props.iconIdentifierYear,this.props.styleFieldIdentifierYear)} 
            </Col>
          </Row>
          {this.renderMessageDateInvalid()}
        </div>
      );
    } else {
      return (
        <div>
          <Row id={`cardValidDate-${this.props.id}`}>
            <Col xs={5}>
              <SelectField
                id={`cardValidDate-month`}
                label="components.checkoutInfo.cardValidDate.label"
                required={true}
                errorMessage="components.checkoutInfo.cardValidDate.monthRequired"
                placeholder="components.checkoutInfo.cardValidDate.month"
                values={this.getMonths()}
                ref={c => {
                  this.monthField = c;
                }}
                changeValue={value => this.changeMonth(value)}
                style={this.props.styleEncodeMonth}
                onBlurFieldToIco={this.props.onBlurFieldToIco}                
                styleFieldIdentifier = {'styleFieldMonth'}
                iconIdentifier = {'iconMonth'}
                callCenterMode={this.props.callCenterMode} 
              />
            </Col>
            <Col xs={1}> 
             {this.renderEyeEncode(this.props.iconEyeMonth,this.props.iconIdentifierMonth,this.props.styleFieldIdentifierMonth)}
            </Col>
            <Col xs={5}>
              <SelectField
                id={`cardValidDate-year`}
                required={true}
                errorMessage="components.checkoutInfo.cardValidDate.yearRequired"
                placeholder="components.checkoutInfo.cardValidDate.year"
                values={this.getYears()}
                ref={c => {
                  this.yearField = c;
                }}
                changeValue={value => this.changeYear(value)}
                style={this.props.styleEncodeYear}
                onBlurFieldToIco={this.props.onBlurFieldToIco}                
                styleFieldIdentifier = {'styleFieldYear'}
                iconIdentifier = {'iconYear'}
                callCenterMode={this.props.callCenterMode}  
              />
            </Col>
            <Col xs={1}>
             {this.renderEyeEncode(this.props.iconEyeYear,this.props.iconIdentifierYear,this.props.styleFieldIdentifierYear)} 
            </Col>
          </Row>
          {this.renderMessageDateInvalid()}
        </div>
      );
    }
  }

  renderEyeEncode(iconEye,iconIdentifier,styleFieldIdentifier){
    if(this.props.renderEye && this.props.callCenterMode)
     return(
      <EyeEncode
        iconEye={iconEye}
        size={20}
        className={this.props.classNameIco}
        iconIdentifier={iconIdentifier}
        styleFieldIdentifier={styleFieldIdentifier}
        onClick={(e) => this.props.handleIcoEye(styleFieldIdentifier,iconIdentifier)} 
      />
    )
  }

  render() {
    return <div>{this.renderCombo()}</div>;
  }
}

CardValidDate.propTypes = propTypes;

export default CardValidDate;



// WEBPACK FOOTER //
// ./src/components/checkoutInfo/cardValidDate/CardValidDate.jsx